import { render } from "./AllGrades.vue?vue&type=template&id=7de60bbd&scoped=true"
import script from "./AllGrades.vue?vue&type=script&lang=js"
export * from "./AllGrades.vue?vue&type=script&lang=js"

import "./AllGrades.vue?vue&type=style&index=0&id=7de60bbd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de60bbd"]])

export default __exports__